import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "footer": null,
      "data-sign": "commodity_importer_info_modal",
      "width": 500,
      "title": _vm.t('进口商详情')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    attrs: {
      "data-sign": "commodity_importer_info_form"
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "prop": "warehouse_code",
      "label": _vm.t('仓库')
    }
  }, [_c('my-operation', [_vm._v(" " + _vm._s(_vm.data.warehouse_code) + " "), _vm.data.warehouse_name ? _c('span', [_vm._v("[" + _vm._s(_vm.data.warehouse_name) + "]")]) : _vm._e()])], 1), _vm._l(_vm.filedConfigList, function (item, index) {
    return [[_vm.$enum.warehouse.ImporterFormControlType.SINGLE_CHECKBOX, _vm.$enum.warehouse.ImporterFormControlType.STATEMENT_CONFIRM].indexOf(item.value_type) === -1 ? _c('a-form-model-item', {
      key: index,
      attrs: {
        "label": _vm.getLabelText(item)
      }
    }, [item.value_type === _vm.$enum.warehouse.ImporterFormControlType.ATTCHMENT ? [_vm.getValueText(item) ? _c('a', {
      attrs: {
        "data-sign": "commodity_importer_info_download",
        "href": _vm.$util.pathToRfsUrl({
          file_path: _vm.getValueText(item),
          filename: _vm.getLabelText(item)
        }, 1),
        "fbu-analyse-name": $t("\u4E0B\u8F7D")
      }
    }, [_vm._v(_vm._s(_vm.t('下载')))]) : _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])] : [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.getValueText(item))))]], 2) : _vm._e()];
  })], 2)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };